module.exports = __webpack_public_path__ + "media/noisy_early_inventions.40203c96.ogg";